import { useEffect } from 'react';
import './mobile.css';

export default function MobileSheet({ title, children, onClose, showFooter = false, footer }) {
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleEsc);
    document.body.style.overflow = 'hidden';

    return () => {
      document.removeEventListener('keydown', handleEsc);
      document.body.style.overflow = '';
    };
  }, [onClose]);

  return (
    <>
      <div className="mobile-sheet-backdrop" onClick={onClose} />
      <div className="mobile-sheet">
        <div className="mobile-sheet-handle" />
        <div className="mobile-sheet-header">
          <h3 className="mobile-sheet-title">{title}</h3>
          <button className="mobile-sheet-close" onClick={onClose}>
            &times;
          </button>
        </div>
        <div className="mobile-sheet-body">
          {children}
        </div>
        {showFooter && footer && (
          <div className="mobile-sheet-footer">
            {footer}
          </div>
        )}
      </div>
    </>
  );
}
